import AuthService from "../../services/authService";
import { LOGIN, LOGOUT, USER_DETAILS } from "../types";

export const login = (params, history) => dispatch => {
  return AuthService.login(params)
    .then(data => {
      // console.log(data);
      dispatch({ type: LOGIN, payload: data });
      history.push("/");
    })
    .catch(err => {
      console.log(err);
    });
};

export const getuserdetails = () => dispatch => {
  return AuthService.userDetails()
    .then(data => {
      // console.log(data);
      dispatch({ type: USER_DETAILS, payload: data });
    })
    .catch(err => {
      console.log(err);
    });
};

export const logout = history => dispatch => {
  AuthService.logout();
  dispatch({ type: LOGOUT });
  history.push("/");
};
